import { Fragment } from "react";
import "./MobileApplication.css";
import androidapp from "../../assets/images/services/mobileapp/androidapp.png";
import androidicon from "../../assets/images/services/mobileapp/androidicon.png";
import iosicon from "../../assets/images/services/mobileapp/iosicon.png";
import customappicon from "../../assets/images/services/mobileapp/customappicon.png";

const MobileApplication = () => {
  return (
    <Fragment>
      <section className="mobileapplication-style">
        <div className="app-banner">
          <div className="banner-overlay"></div>
          <div
            className="banner-content"
            data-aos="fade-down"
            data-aos-offset="300"
          >
            <h1 className="fw-bold">Mobile Application Development</h1>
            <p>
              Kairaa creates native, cross-platform and progressive web
              applications with stable performance, human-centered design and a
              unique selling proposition to stand out in a fierce market.
            </p>
          </div>
        </div>
        <div className="mobileapp-process">
          <div className="container"> 
            <div className="row">
              <div className="col-lg-5 col-md-12">
                <div className="mobile-with-shape">
                  <span class="bg-shape"></span>
                  <img
                    src={androidapp}
                    alt="img-not-found"
                    data-aos="zoom-in-up"
                    data-aos-delay="200"
                    data-aos-duration="1200"
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-12">
                <h4
                  className="mb-4"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1200"
                >
                  Trusted mobile app development company in India
                </h4>
                <p
                  className="mb-5"
                  data-aos="fade-up-left"
                  data-aos-delay="400"
                  data-aos-duration="1200"
                >
                  Providing a cluster of mobile app development requirements
                  such as React Native, iOS app development, and Flutter
                  cross-platform apps across different industry verticals, we
                  create high-quality solutions for clients globally. As the
                  most trusted mobile app development company, our experts
                  follow an agile approach and utilize cutting-edge technologies
                  for establishing next-generation mobile apps. The development
                  process begins with a deep understanding of the
                  customer-centric approach for acquiring successful results and
                  standing ahead of the competition.
                </p>
              </div>
            </div>
            <div className="mobile-why-chooseus">
              <h4
                className="text-center"
                data-aos="fade-down"
                data-aos-delay="600"
                data-aos-duration="1200"
              >
                Why choose our mobile app development company?
              </h4>
              <p
                data-aos="fade-down"
                data-aos-delay="800"
                data-aos-duration="1200"
                className="text-center"
              >
                Selecting a renowned mobile app development company for
                solutions provides numerous benefits. It comes with faster
                development times and cost-effectiveness enabling ongoing
                maintenance and support. Besides, it Possesses a comprehensive
                understanding of mobile app development right from initial
                planning to deployment and maintenance. It helps in defining the
                app’s purpose, target audience and features ensuring that it
                aligns with business objectives. We provide quality services and
                business growth strategies for businesses. As a leading mobile
                app development company, we strive to establish premium-quality
                mobile applications for clients at a global level.
              </p>
            </div>
          </div>

          <div className="container mt-5">
            <div className="">
              <div className="row gy-4 d-flex justify-content-center">
                <div class="col-lg-4 col-md-6">
                  <div
                    className="mobileapp-card"
                    data-aos="zoom-in-up"
                    data-aos-delay="200"
                    data-aos-duration="1200"
                  >
                    <div className="d-flex justify-content-between">
                      <h6 className="d-flex align-items-center">
                        Android App Development
                      </h6>
                      <div className="mobileapp-icon">
                        <img src={androidicon} alt="img-not-found" />
                      </div>
                    </div>
                    <p class="">
                      Android is a widely-used open-source operating system for
                      mobile apps. Our expert team crafts distinctive business
                      applications to keep you ahead of the competition. Using
                      the best frameworks and tools, our Android app developers
                      design adaptable and cost-efficient solutions that are
                      user-friendly. Embrace digital transformation with our
                      team.
                    </p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6">
                  <div
                    className="mobileapp-card"
                    data-aos="zoom-in-up"
                    data-aos-delay="400"
                    data-aos-duration="1200"
                  >
                    <div className="d-flex justify-content-between">
                      <h6 className="d-flex align-items-center">
                        iOS App Development
                      </h6>
                      <div className="mobileapp-icon">
                        <img src={iosicon} alt="img-not-found" />
                      </div>
                    </div>
                    <p class="">
                      A strong brand value, coupled with the secure and
                      high-performing interactive designs, has made iOS popular
                      among the masses. Our skilled iOS developers can help you
                      engineer forward-thinking business applications. We
                      deliver striking designs and custom iOS solutions across
                      various domains, primarily using swift and objective C.
                    </p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6">
                  <div
                    className="mobileapp-card"
                    data-aos="zoom-in-up"
                    data-aos-delay="600"
                    data-aos-duration="1200"
                  >
                    <div className="d-flex justify-content-between">
                      <h6 className="d-flex align-items-center">
                        Cross Platform Mobile Apps
                      </h6>
                      <div className="mobileapp-icon">
                        <img src={customappicon} alt="img-not-found" />
                      </div>
                    </div>
                    <p class="">
                      React Native | Flutter Cross-platform development allows
                      app development companies to create applications
                      compatible with multiple operating systems. Our team
                      specializes in designing such applications for clients
                      across various domains. We can transform your business
                      with native-like apps for both iOS and Android, helping
                      you excel in the digital world.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default MobileApplication;
